<template>
	<div class="parent" style="height:calc(100vh - 50px);">

		<dialogue
			:title="'Add Box'"
			:paragraph="box_dialogue_text"
			:button_names="['Yes','No']"
			:show="box_dialogue"
			v-on:dialogue="addBox"
			v-on:cancel="cancelBox"
		></dialogue>

		<checkitem
			:show=checkOpen
			:isIn=checkIsIn
			:itemId=term
			v-on:cancel="closeCheck"
			v-on:dialogue="checkItem"
		></checkitem>

		<div class="scroll">
			<layout-2
			:id=pageid
			:navbar=true
			:title="'Edit Inventory Item'"
			:use_radio=false
			:term=term
			style="width:100%;"
			:key=updateKey
			v-on:save="checkItem"
			:reroute=false></layout-2>

			<hr style="margin-left:25px;margin-right:25px;"/>

			<div style="padding:16px;">
				<inventorypics :inventorypic_id="term" :imageCount=99 :height="'300px'" style="width:100%"></inventorypics>
			</div>

			<hr style="margin-left:25px;margin-right:25px;"/>

			<div class="box">
				<b-form-file
					class="upload-box text-nowrap text-truncate"
					size="lg"
					v-model="uploadFiles"
		            :state="Boolean(uploadFiles)"
					placeholder="Choose or Drop files here"
					drop-placeholder="Drop files here"
					@input="select()"
					multiple
				></b-form-file>
				<br/>
				<img v-if="uploadFiles.length>0" id="file_upload" src="#" style="height:10vh"></img>
				<p id="more"></p>

				<hr style="margin-left:25px;margin-right:25px;"/>

				<!--<input v-if="detectMobile()==true" v-on:change="takePicture" type="file" accept="image/*" capture="camera">

				<hr v-if="detectMobile()==true" style="margin-left:25px;margin-right:25px;"/>-->

				<div class="uploading-box" v-bind:class="{ hidden: !loading }">
					<div v-bind:id="'loading-progress'" class="uploading-bar-green" v-bind:style="'width:'+loadingBarWidth+'%'"></div>
				</div>
				<!--<button :disabled="!ready" v-on:click="upload()" v-bind:class="{ hidden: uploading}">Upload</button>-->
				<div class="uploading-box" v-bind:class="{ hidden: !uploading }">
					<div v-bind:id="'progress'" class="uploading-bar">
						<p v-bind:id="'progress-text'" class="upload-text"></p>
					</div>
				</div>
			</div>
		</div>

		<div class="nav-bar">
			<div>
				<button v-for="(item, index) in nav_items" v-if="perms.includes(nav_item_perms[index])" v-on:click="button(item)">{{item}}</button>
				<button v-on:click="check(false)">Check Out</button>
				<button v-on:click="check(true)">Check In</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			perms:[],
			pageid:PAGES.EDIT_INVENTORY_PAGE,
			pageid2:PAGES.ADD_NEW_BOX_PAGE,
			uploadFiles:[],
			files:[],
			uploading:false,
			loading:false,
			ready:false,
			progressBar:null,
			loadingBar:null,
			loadingBarWidth:0,
			nav_items:['Inventory List', 'Edit Inventory List', 'Scan Item'],
			nav_item_perms:['88','88','89'],
			checkOpen:false,
			checkIsIn:false,
			updateKey:0,
			box_dialogue:false,
			box_dialog_text:'',
			box_id:null,
		}
	},
	async created () {
		this.perms = api.getPerms();
	},
	methods:{
		select(){
			this.file=null;
			this.loading=true;
			this.ready=false;
			this.loadingBarWidth = 0
			var length = this.uploadFiles.length

			var widths = []
			var promises = []

			for(let i = 0;i<length;i++){
				promises.push(new Promise((resolve, reject) => {
					var reader = new FileReader()
					reader.onload = function(e){
						document.getElementById("file_upload").src = e.target.result
						this.files[i] = {imageName:this.uploadFiles[i].name, imageData:e.target.result}
						resolve(null);
					}.bind(this);

					reader.onprogress = function(e){
						if (e.lengthComputable) {
			                widths[i] = parseInt( (((e.loaded / e.total) * 100) / length), 10 );
							this.loadingBarWidth = widths.reduce((a, b) => a + b, 0)
			            }
					}.bind(this);

					reader.onerror = function(e){
						console.log(e)
						this.uploading=false;
						this.loading=false;
						this.ready=false;
						this.uploadFiles = []
						this.files = []
						document.getElementById("file_upload").src = "#"
						document.getElementById("more").innerHTML = ""

						alert("error: File could not be read")
						reject(null);
					}.bind(this);

					reader.readAsDataURL(this.uploadFiles[i])
		        }));
			}

			Promise.all(promises).then((results) => {
				this.loading=false;
				this.ready=true;

				if(length>1){
					document.getElementById("more").innerHTML = "+ "+(this.uploadFiles.length-1)+" more"
				}else{
					document.getElementById("more").innerHTML = ""
				}

				this.upload();
			});
		},
		upload(){
			this.uploading=true;
			this.ready=false;
			this.progressBar.style = "width:0%"
			var fileCount = this.files.length

			api.postDataImage(
				{
					data:{
						pageid:this.pageid,
						files:this.files,
						data:[
							this.term,
						]
					}
				},
				this.progressBar
			).then((res) => {
				this.uploadFiles = []
				this.files = []
				document.getElementById("file_upload").src = "#"
				document.getElementById("more").innerHTML = ""
			}).finally((res) => {
				this.uploading=false;
				this.loading=false;
				this.ready=false;

				router.go(0)
			})
		},
		async button (name){
			api.postData(
				{
					type:"button",
					data:{
						pageid:this.pageid,
						buttonname:name,
					}
				}
			).then((res) => {
				if(res.data.data.to!=null) {
					if(res.data.data.useterm) {
						router.push('/'+res.data.data.to+'?q='+this.term);
					} else {
						router.push('/'+res.data.data.to);
					}
				}
			});
		},

		closeCheck(){
			this.checkOpen=false;
		},
		check(isIn){
			this.checkIsIn=isIn;
			this.checkOpen=true;
		},
		checkItem(itemId){
			if(itemId==undefined) itemId = this.term
			this.openBoxDialogue(itemId);
			this.updateKey++;
		},

		openBoxDialogue(itemId){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid2,
						itemId:itemId,
					}
				}
			).then((res) => {

				var boxId = res.data.data.column_data[0][0]
				if(boxId!="null") {
					this.box_id = boxId;
					this.box_dialogue_text = "Box "+boxId+" does not exist.\nCreate a new box?";
					this.box_dialogue = true;
				}else{
					router.go(-1)
				}
			});
		},
		cancelBox(){
			this.box_dialogue = false;
			router.go(-1)
		},
		addBox(buttonName){
			if(buttonName=="Yes"){
				api.postData(
					{
						type:"insert",
						data:{
							pageid:this.pageid2,
							boxId:this.box_id,
						}
					}
				).then((res) => {
					
				});
			}
		},
	},
	mounted: function () {
		this.$nextTick(function () {
			this.progressBar = document.getElementById("progress")
			this.loadingBar = document.getElementById("loading-progress")
			this.progressBar.style = "width:0%"
			this.loadingBar.style = "width:0%"
		})
	}
}
</script>

<style scoped>
.box{
    margin-right: 10%;
    margin-left: 10%;
    text-align:center;
    border: 3px solid #35495E;
    border-radius: 20px;
	padding:16px;
}

.field{
    padding:10px;
    text-align:center;
}

.textlabel{
    white-space:nowrap;
    color:#35495E;
}

.textfield{
    width:100%;
}

.title{
    font-size:30px;
    font-weight:bold;
    color:#35495E;
}

.smalltext{
    font-size: 12px;
	color: #888888;
}

.upload-box{
    width:75%;
	z-index:3;
}

.custom-file-input ~ .custom-file-label::after {
  content: 'sh';
}

</style>



// WEBPACK FOOTER //
// src/components/edit/Edit_Inventory_Items.vue